<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="ticketCustomMessageModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              CF enterprise Proceedings of {{ domain }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section v-if="showRequiredTasks">
                <h4>You have missed the following required task:</h4>
                <ul class="list-unstyled">
                  <li v-for="(task, index) of requiredTasks" :key="index" class="p-2 border-bottom">
                    <i class="fa fa-arrow-right text-primary mr-3 pull-left" /> <span v-html="task.text" />
                  </li>
                </ul>
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-sm btn-success" @click="checkAllTask">Please Acknowledge</button>
                    <button class="btn btn-sm btn-primary pull-right" type="button" @click="showRequiredTasks = false">Continue</button>
                  </div>
                </div>
              </section>
              <section v-else>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Action:</label>
                      <select class="form-control h-43" v-model="action" required>
                        <option value="Leave in pending" v-if="task.status !== 'customerReview'">{{ (task.status === 'pending') ? 'Leave in pending' : 'Leave in review'}}</option>
                        <option value="Move to under review" v-if="task.status === 'pending'" :disabled="requiredTasks.length > 0">Move to under review</option>
                        <option value="Move to under customer review" v-if="task.status === 'review' || task.status === 'pending'" :disabled="requiredTasks.length > 0">Move to under customer review</option>
                        <option value="Move to finished" :disabled="requiredTasks.length > 0">Move to finished</option>
                      </select>
                    </div>
                  </div>
                  <section v-if="task.ticketId">
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" :required="action === 'Leave in pending' || sendTicketReply" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">
                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />
                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div class="row mt-3" v-else>
                    <div class="col-md-12">
                      <span class="text-danger">Ticket ID is not associated with this task.</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-default" type="button" @click="showRequiredTasks = true" v-if="requiredTasks.length > 0">Back</button>
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="action === 'Leave in pending' && !task.ticketId">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init'
import swal from "sweetalert2";
import statisticsMixin from "@/mixins/statisticsMixin";
import { isMultiDocUser, getOrderedHostingDocs } from '@/utils/firestoreUtils';
import axios from "axios";
export default {
  name: "ticketCustomMessage",
  mixins: [statisticsMixin],
  props: {
    presetMacros: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      type: null,
      task: {},
      loading: false,
      sendTicketReply: false,
      showRequiredTasks: false,
      index: null,
      action: 'Leave in pending',
      requiredTasks: []
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    domain() {
      return (this.task.domain) ? this.task.domain : ''
    }
  },
  methods: {
    async sendSlackNotification(msg, showButton) {
      return
      try {
        await this.$http.post('utilities/send-slack-notification', {
          grant_type: 'token',
          msg,
          showButton,
        });
      } catch (e) {
        console.log(e.toString())
      }
    },
    formatPrimaryDomainName(value) {
      const match = value.match(/(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9]+)+)/i);

      // If there's a match, return the domain group
      if (match && match.length > 1) {
        return match[1];
      } else {
        return 'Account Based Operation'; // Return null if no match found
      }
    },
    async checkAllTask() {
      console.log(this.requiredTasks)
      this.loading = true;
      for (let task of this.requiredTasks) {
        if (!task.heading) {
          if (this.type === 'pending') {
            task.pendingIsChecked = true;
            task.pendingCheckedBy = this.user.firstName + ' ' + this.user.lastName;
          } else {
            task.reviewIsChecked = true;
            task.reviewCheckedBy = this.user.firstName + ' ' + this.user.lastName
          }
        }
      }
      console.log('updating')
      await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
        checklist: this.task.checklist,
        modified: new Date().toISOString()
      });
      console.log('updated')
      this.loading = false;
      this.requiredTasks = [];
      this.showRequiredTasks = false;
    },
    async load(task, index, type) {
      this.requiredTasks = [];
      this.showRequiredTasks = false;
      $('#ticketCustomMessageModal').modal('show');
      this.loading = true;
      this.task = task
      this.type = type
      await this.getRequiredTasks();
      console.log(this.requiredTasks)
      if (this.requiredTasks.length > 0) {
        this.showRequiredTasks = true;
      }
      this.loading = false;
      this.index = index
    },
    async getRequiredTasks() {
      this.requiredTasks = [];
      for (let task of this.task.checklist) {
        if (!task.heading) {
          if (this.type === 'pending' && !task.pendingIsChecked) {
            this.requiredTasks.push(task)
          } else if (this.type === 'review' && !task.reviewIsChecked) {
            this.requiredTasks.push(task)
          }
        }
      }
    },
    async useThisMacro(macro) {
      try {
        this.loading = true;

        let msg = macro.message || macro;
        const userUID = this.task.uid;
        const domain = this.task.domain;

        // Fetch user information
        const userRef = await db.collection('users').doc(userUID).get();
        if (!userRef.exists) {
          throw new Error("User not found.");
        }
        const user = userRef.data();

        const username = `${user.firstName} ${user.lastName}`;

        // Replace static placeholders
        const placeholders = {
          '{name}': username,
          '{firstName}': user.firstName,
          '{lastName}': user.lastName,
          '{teamMember}': this.user.firstName,
          '{domain}': domain,
          '{signature}': this.user.signature,
        };

        for (const [placeholder, value] of Object.entries(placeholders)) {
          msg = msg.replace(new RegExp(placeholder, 'g'), value);
        }

        // Check if domain-specific data is needed
        if (/{ipaddress}|{nameservers}|{stagingurl}/.test(msg)) {
          const docsToFetch = isMultiDocUser(userUID)
              ? await getOrderedHostingDocs(userUID)
              : [db.collection('hostingAccounts').doc(userUID)];

          let selectedAccount = null;

          for (const docRef of docsToFetch) {
            const hostingAccountRef = await docRef.get();
            if (!hostingAccountRef.exists) continue;

            const { accounts } = hostingAccountRef.data();
            const match = accounts.find(
                el =>
                    el.primary.domain === domain ||
                    el.addon.some(addon => addon.domain === domain)
            );

            if (match) {
              if (match.primary.domain === domain) {
                selectedAccount = match.primary;
              } else {
                const addon = match.addon.find(el => el.domain === domain);
                if (addon) {
                  addon.serverIP = match.primary.serverIP;
                  selectedAccount = addon;
                }
              }
              if (selectedAccount) break;
            }
          }

          if (selectedAccount) {
            const ip = selectedAccount.serverIP || 'N/A';
            const nameservers = selectedAccount.cloudflare.nameserver1
                ? `\n${selectedAccount.cloudflare.nameserver1}\n${selectedAccount.cloudflare.nameserver2 || 'N/A'}\n`
                : 'N/A';
            const stagingUrl = `${domain.replace(/\./g, '')}.bigscoots-staging.com`;

            msg = msg
                .replace(/{ipaddress}/g, ip)
                .replace(/{nameservers}/g, nameservers)
                .replace(/{stagingurl}/g, stagingUrl);
          }
        }

        // Update ticket UI
        this.ticketMessage = msg;
        this.ticketStatus = macro.status || 'Answered';
        this.ticketPriority = macro.priority || 'Low';

      } catch (error) {
        console.error("Error in useThisMacro:", error);
        this.ticketMessage = "An error occurred while processing the macro.";
        this.ticketStatus = "Error";
        this.ticketPriority = "High";
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      try {
        this.loading = true
        if (((this.ticketMessage && this.action === 'Leave in pending') || this.sendTicketReply) && this.task.ticketId) {
          await this.$http.post('utilities/send-migration-ticket-reply', {
            grant_type: 'token',
            message: this.ticketMessage,
            status: this.ticketStatus,
            priority: this.ticketPriority,
            ticketId: this.task.ticketId,
            name: this.user.firstName + ' ' + this.user.lastName,
            hostBillId: this.user.hostBillId,
          })
          if (this.action === 'Leave in pending' && this.type === 'pending') {
            await this.addLog({
              uid: this.task.uid,
              primaryPlan: this.formatPrimaryDomainName(this.task.domain),
              message: `User has replied to ticket for CF Enterprise task, domain: ${this.domain} and leave it in pending tab. Ticket No.: ${this.task.ticketId}`,
              level: "info"
            })
          } else if (this.action === 'Leave in pending' && this.type === 'review') {
            await this.addLog({
              uid: this.task.uid,
              primaryPlan: this.formatPrimaryDomainName(this.task.domain),
              message: `User has replied to ticket for CF Enterprise task, domain: ${this.domain} and leave it in review tab.  Ticket No.: ${this.task.ticketId}`,
              level: "info"
            })
          } else {
            await this.addLog({
              uid: this.task.uid,
              primaryPlan: this.formatPrimaryDomainName(this.task.domain),
              message: `User has replied to ticket for CF Enterprise task, domain: ${this.domain}. Ticket No.: ${this.task.ticketId}`,
              level: "info"
            })
          }
        }
        try {
          await this.updateGlobalIDs(this.task.cssIds, 'css')
          await this.updateGlobalIDs(this.task.jssIds, 'js')
        } catch (e) {
          console.log('error in adding gloval IDs')
        }
        const from = (this.type === 'pending') ? 'pending' : (this.type === 'review') ?  'review' : 'customerReview'
        if (this.action === 'Move to under review') {
          await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
            status: 'review',
            modified: new Date().toISOString(),
            movedAt: new Date().toISOString()
          })
          $('#collapse_' + this.index + this.type).collapse('hide')

          const msg = `CF Enterprise task for domain ${this.domainAdjustment(this.domain)} has been moved from ${from} to review by ${this.user.firstName} ${this.user.lastName} and is ready for review.`
          await this.addRecentActivity({
            type: 'info',
            actionType: `CF ENT`,
            message: msg,
            customer: {
              domain: this.domain,
              email: this.task.email
            }
          })
          try {
            await this.removeAdminActiveTask({taskId: this.task.docId});
          } catch (e) {
            console.log(e.toString())
          }
          await this.sendSlackNotification(msg, true)
          await this.addLog({
            uid: this.task.uid,
            primaryPlan: this.formatPrimaryDomainName(this.task.domain),
            message: `User has moved CF ENT task ${this.domain} from ${from} to review.`,
            level: "info"
          })
        } else if (this.action === 'Move to under customer review') {
          await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
            status: 'customerReview',
            modified: new Date().toISOString(),
            movedAt: new Date().toISOString()
          })
          $('#collapse_' + this.index + this.type).collapse('hide')

          const msg = `CF Enterprise task for domain ${this.domainAdjustment(this.domain)} has been moved from ${from} to customer review by ${this.user.firstName} ${this.user.lastName} and is ready for customer review.`
          await this.addRecentActivity({
            type: 'info',
            actionType: `CF ENT`,
            message: msg,
            customer: {
              domain: this.domain,
              email: this.task.email
            }
          })
          try {
            await this.removeAdminActiveTask({taskId: this.task.docId});
          } catch (e) {
            console.log(e.toString())
          }
          await this.sendSlackNotification(msg, true)
          await this.addLog({
            uid: this.task.uid,
            primaryPlan: this.formatPrimaryDomainName(this.task.domain),
            message: `User has moved CF ENT task ${this.domain} from ${from} to customer review.`,
            level: "info"
          })
          // increment count
          try {
            // await this.incrementCountBasedOnType(this.user, 'CFEnt')
          } catch (e) {
            console.log('line 370', e.toString())
          }
        } else if (this.action === 'Move to finished') {
          await db.collection('CFEnterpriseRequests').doc(this.task.docId).update({
            status: 'finished',
            modified: new Date().toISOString(),
            movedAt: new Date().toISOString()
          })
          $('#collapse_' + this.index + this.type).collapse('hide')
          const msg = `${this.domainAdjustment(this.domain)} has been moved from ${from} to finished by ${this.user.firstName} ${this.user.lastName}.`
          await this.addRecentActivity({
            type: 'info',
            actionType: `CF ENT`,
            message: msg,
            customer: {
              domain: this.domain,
              email: this.task.email
            }
          })
          try {
            await this.removeAdminActiveTask({taskId: this.task.docId});
          } catch (e) {
            console.log(e.toString())
          }
          console.log('I was called');
          await this.sendSlackNotification(msg, false)
          await this.addLog({
            uid: this.task.uid,
            primaryPlan: this.formatPrimaryDomainName(this.task.domain),
            message: `User has moved CF Enterprise task for domain ${this.domain} from ${from} to finished.`,
            level: "info"
          })
          try {
            await this.incrementCountBasedOnType(this.user, 'cfEnterprise')
          } catch (e) {
            console.log('line 392', e.toString())
          }
        }
        this.loading = false
        this.ticketMessage = null
        this.action = 'Leave in pending'
        $('#ticketCustomMessageModal').modal('hide');
      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }
    },
    async updateGlobalIDs (newIds, type) {
      let existingIds = {};
      const res = await db.collection('idsCollection').doc(`perfmatters-${type}`).get()
      if (res.exists) {
        existingIds = res.data().ids || {};
      }
      newIds.forEach(id => {
        const trimmedId = id.trim();
        if (trimmedId) {
          // Increment the count if the ID already exists, otherwise set it to 1
          existingIds[trimmedId] = (existingIds[trimmedId] || 0) + 1;
        }
      });
      if (res.exists) {
        await db.collection('idsCollection').doc(`perfmatters-${type}`).update({
          ids: existingIds
        })
      } else {
        await db.collection('idsCollection').doc(`perfmatters-${type}`).set({
          ids: existingIds
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-lg {
  max-width: 1200px !important;
}

.preset {
  height: 230px;
  overflow: auto;

  li {
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.3);
    padding: 2px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
